"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var addLayoutEffectOnMount = function (callback) {
    return ad_hok_1.addLayoutEffect(callback, []);
};
exports.default = addLayoutEffectOnMount;
